import { createContext, useState } from 'react';
import {
    createUpdateFormData,
    createUpdateMultipleFields,
    createResetForm,
    getInitialFormData,
} from './triggerFormUtils.js';

export const TriggerFormContext = createContext();

export const TriggerFormProvider = ({ children, initialData = {} }) => {
    const [formData, setFormData] = useState(getInitialFormData(initialData));
    const [headers, setHeaders] = useState(null);
    const [mode, setMode] = useState();
    // Shared buffer for the Email Addresses field's not-yet-committed text —
    // needs to live here (not local state on EmailAddressInput) so
    // FieldsSelector's "insert Field chip at cursor" can splice into the
    // buffer being typed, rather than overwriting the committed emailAddress
    // array (mirrors TriggersEdit.jsx's Redux modalState.emailAddressTmp).
    const [emailAddressTmp, setEmailAddressTmp] = useState('');

    // Create helper functions
    const updateFormData = createUpdateFormData(setFormData);
    const updateMultipleFields = createUpdateMultipleFields(setFormData);
    const resetForm = createResetForm(setFormData, initialData);

    const value = {
        formData,
        setFormData,
        updateFormData,
        updateMultipleFields,
        resetForm,
        headers,
        setHeaders,
        mode,
        setMode,
        emailAddressTmp,
        setEmailAddressTmp,
    };

    return (
        <TriggerFormContext.Provider value={value}>
            {children}
        </TriggerFormContext.Provider>
    );
};
